/**
 * Hook: MenuBar real data — agent stats + FLZ balance
 * Polls every 30s
 */
import axios from 'axios'
import { useEffect, useState } from 'react'
import { API_URL } from '../../../config/api'

export interface AgentStats {
  total_agents: number
  active_agents: number
  platform_agents: number
  user_agents: number
}

export interface MenuBarData {
  agentStats: AgentStats | null
  flzBalance: number
  loading: boolean
}

export function useMenuBarData(): MenuBarData {
  const [agentStats, setAgentStats] = useState<AgentStats | null>(null)
  const [flzBalance, setFlzBalance] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { setLoading(false); return }
    const headers = { Authorization: `Bearer ${token}` }

    const fetch = async () => {
      try {
        const [agentRes, walletRes] = await Promise.allSettled([
          axios.get(`${API_URL}/api/admin/agent-stats`, { headers }),
          axios.get(`${API_URL}/api/wallet/balance`, { headers }),
        ])
        if (agentRes.status === 'fulfilled') {
          setAgentStats(agentRes.value.data as AgentStats)
        }
        if (walletRes.status === 'fulfilled') {
          const d = walletRes.value.data as { wallet_balance?: number }
          setFlzBalance(d.wallet_balance ?? 0)
        }
      } catch { /* silent */ }
      finally { setLoading(false) }
    }

    void fetch()
    const interval = setInterval(() => { void fetch() }, 30000)
    return () => clearInterval(interval)
  }, [])

  return { agentStats, flzBalance, loading }
}
